// Dependency
import React from 'react';

// Styles
import * as errorStyles from './error.module.scss';

// Template
const NotificationSuccess = ({ isOpen, toggleNotification, children }) => {
  return (
    <div className={`${errorStyles.cdErrorBox} ${errorStyles.cdSuccessBox} ${isOpen ? errorStyles.isOpen : ''}`} >
        <div className={errorStyles.cdErrorBoxIcon}>
          <i className="material-icons">check</i>
        </div>
        <div className={errorStyles.cdErrorBoxContent}>
          { children }
        </div>
        <button className={errorStyles.cdErrorBoxClose} onClick={() => { toggleNotification({ type: '', data: null }); }}>
          <i className="material-icons">close</i>
        </button>
    </div>
  );
};

export default NotificationSuccess;